import api from "../services/api";

const path = "imagembotaopontoacesso";

export const getImagesButtonsPointsAccess = async ({ IdPontoAcesso }) => {
  const filter = IdPontoAcesso ? `?IdPontoAcesso=${IdPontoAcesso}` : "";
  return await api.get(`${path}${filter}`);
};

export const findImageButtonPointAccess = async ({ id }) => {
  return await api.get(`${path}/${id}`);
};

export const editImageButtonPointAccess = async ({ id, body }) => {
  return await api.put(`${path}/${id}`, body);
};

export const createImageButtonPointAccess = async ({ body }) => {
  return await api.post(`${path}`, body);
};

export const deleteImageButtonPointAccess = async ({
  idPointAccess,
  idImage,
}) => {
  let filter = idPointAccess ? `?IdPontoAcesso=${idPointAccess}` : "";
  filter += `&IdImagem=${idImage}`;
  return await api.delete(`${path}${filter}`);
};
